import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import NewHeader from "../../../Layouts/NewHeader";
import NewFooter from "../../../Layouts/NewFooter";

const Privacy = () => {
  return (
    <>
      <div
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh", overflowX: "hidden" }}
      >
        <NewHeader />
        <div
          className="container"
          style={{ flex: "1", paddingTop: "20px" }}
        >
          <div
            style={{
              fontSize: "18px",
              paddingTop: "10px",
            }}
            className="card px-5 py-5 my-3 m-auto shadow-lg mt-2"
          >
            <h4 className="mt-4" style={{ color: "#212529", fontSize: "32px" }}>
              Refund Policy
            </h4>
            <ol className="fs-16 mt-2">
              <li>
                <p className="mb-1">If Recharge token has not been generated</p>
                <p className="mb-1">
                  If your payment has been debited but a recharge token has not
                  been generated, there is a 30 day refund period.
                </p>
                <p className="mb-1">
                  <p className="mb-1">
                    Within this time, the consumer has to submit a claim with
                    the following details:
                  </p>
                  <ol>
                    <li>Consumer and Meter number</li>
                    <li>Date of transaction</li>
                    <li>Amount of transaction</li>
                    <li>Proof of debit of amount from Bank AC/ Card/ Wallet</li>
                  </ol>
                </p>
                <p className="mb-1">
                  After successful verification, your amount will be refunded
                  within a period of maximum 7 (seven) days.
                </p>
              </li>
              <li>
                <p className="mb-1">If Recharge Token has been generated:</p>
                <p className="mb-1">
                  Once the recharge token has been generated by the system, no
                  amount will be refundable. However, the consumer can request
                  for a duplicate copy of the recharge token to be entered in
                  the meter.
                </p>
              </li>
            </ol>
          </div>
        </div>
        <NewFooter />
      </div>
    </>
  );
};

export default Privacy;
